const footerDropdownToggles = document.querySelectorAll('.footer-dropdown-toggle');

footerDropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
        const dropdown = toggle.nextElementSibling as HTMLElement;
        if (dropdown.classList.contains('expanding') || dropdown.classList.contains('collapsing')) {
            return;
        }
        if (dropdown.classList.contains('expanded')) {
            collapse(dropdown);
        } else {
            footerDropdownToggles.forEach(t => {
                const d = t.nextElementSibling as HTMLElement;
                if (d !== dropdown && d.classList.contains('expanded')) {
                    collapse(d);
                }
            });
            expand(dropdown);
        }
    });
});

function expand(e: HTMLElement) {
    e.classList.add('expanding');
    e.style.height = `${e.scrollHeight}px`;
    setTimeout(() => {
        e.style.height = 'auto';
        e.classList.remove('expanding');
        e.classList.add('expanded');
    }, 300);
}

function collapse(e: HTMLElement) {
    e.classList.remove('expanded');
    e.classList.add('collapsing');
    e.style.height = `${e.scrollHeight}px`;
    setTimeout(() => {
        e.style.height = '0px';
        setTimeout(() => {
            e.style.height = '';
            e.classList.remove('collapsing');
        }, 300);
    }, 0);
}
